export function kliknalPobierzDokumentacje() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest('[data-ga-event-kliknal-pobierz-dokumentacje-techniczna]');
        if (!target) return;

        window.dataLayer = window.dataLayer || [];

        const sectionTitle =
            target.getAttribute(
                'data-ga-event-kliknal-pobierz-dokumentacje-techniczna-section-title'
            ) || '';

        const fileTitle = target.querySelector('.file__title')?.textContent || '';
        const url = target.getAttribute('href') || '';

        // 👉 NAJPIERW próbujemy pobrać z atrybutu targeta
        const productCode =
            target.getAttribute(
                'data-ga-event-kliknal-pobierz-dokumentacje-techniczna-section-product-code'
            ) ||
            document.querySelector('#hero-title')?.textContent ||
            '';

        const currentUrl =
            window.location.origin +
            window.location.pathname +
            window.location.search;

        window.dataLayer.push({
            event: 'kliknal_pobierz_dokumentacje_techniczna',
            section_title: sectionTitle,
            title: fileTitle,
            document_url: url,
            product_code: productCode,
            page_url: currentUrl,
        });
    });
}
